import { all, put, takeEvery } from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import { shippingClient } from 'domain/HttpClients';
import { transformFormValues } from 'domain/stockUnit/model';

import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { CREATE_FORM_NAME } from 'domain/stockUnit/components/create/constants';

function* registerStockUnitInfo(values) {
  const data = transformFormValues(values);
  try {
    const response = yield shippingClient
      .Post('api/sku')
      .withData(data)
      .send();
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}

function* doCreateStockUnit(context, action) {
  if (action.payload.name !== CREATE_FORM_NAME) return;

  yield put(startSubmit(CREATE_FORM_NAME));

  try {
    const {
      payload: { values },
    } = action;

    yield registerStockUnitInfo(values);
    // yield put(reset(CREATE_FORM_NAME));
    yield put(
      showNotification(
        I18n.str('stockKeepingUnitCreatedSuccessfully', 'Stock Keeping Unit Created Successfully'),
        'success',
      ),
    );
    // setTimeout(() => {
    //   // context.history.push('/stock-unit/query');
    // }, 2000);
  } catch (e) {
    yield put(
      showNotification(I18n.str('error', 'Something Went Wrong, Please try again'), 'error'),
    );
    console.error(e);
  } finally {
    yield put(stopSubmit(CREATE_FORM_NAME));
  }
}

function* watcher(context) {
  yield all([takeEvery(doSubmit().type, doCreateStockUnit, context)]);
}

export default watcher;
